import React, { useState } from 'react';
import './ModalStyles.css';
import apiService from '../../services/api';

const AddCategoryModal = ({ isOpen, onClose, onSave, categories = [] }) => {
  const [categoryData, setCategoryData] = useState({
    name: '',
    shortCode: '',
    description: '',
    addAsSubCat: false,
    parentId: ''
  });
  const [isSaving, setIsSaving] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCategoryData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryData.name.trim()) {
      alert('Please fill in the category name');
      return;
    }
    if (categoryData.addAsSubCat && !categoryData.parentId) {
      alert('Please select a parent category');
      return;
    }

    setIsSaving(true);
    setApiError(null);

    try {
      const payload = {
        name: categoryData.name.trim(),
        short_code: categoryData.shortCode.trim(),
        description: categoryData.description.trim(),
        category_type: 'product',
        add_as_sub_cat: categoryData.addAsSubCat ? 1 : 0,
        parent_id: categoryData.addAsSubCat && categoryData.parentId ? categoryData.parentId : undefined
      };

      const res = await apiService.createCategory(payload);
      const createdCategory = res.data || res;

      if (onSave) {
        onSave(createdCategory);
      }

      setCategoryData({ name: '', shortCode: '', description: '', addAsSubCat: false, parentId: '' });
      setApiError(null);
      onClose();
    } catch (err) {
      setApiError('Failed to create category: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setCategoryData({ name: '', shortCode: '', description: '', addAsSubCat: false, parentId: '' });
    setApiError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal" style={{ maxWidth: '540px', width: '95%', borderRadius: '12px', overflow: 'visible', background: 'var(--etpos-card, #fff)', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text, #1e293b)' }}>Add Category</h3>
          <button onClick={handleClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: '1.25rem', lineHeight: 1, padding: '0.25rem' }}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ padding: '1.5rem 1.5rem' }}>
            {apiError && (
              <div style={{
                marginBottom: '1rem',
                padding: '0.6rem 0.9rem',
                background: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '6px',
                color: '#991b1b',
                fontSize: '0.85rem'
              }}>
                {apiError}
              </div>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>
                  Category Name <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={categoryData.name}
                  onChange={handleChange}
                  placeholder="Category name"
                  required
                  style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none' }}
                  autoFocus
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>Category Code</label>
                <input
                  type="text"
                  name="shortCode"
                  value={categoryData.shortCode}
                  onChange={handleChange}
                  placeholder="HSN / Short code"
                  style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none' }}
                />
                <p style={{ margin: '0.2rem 0 0', fontSize: '0.72rem', color: '#6b7280' }}>Same as HSN code</p>
              </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>Description</label>
              <textarea
                name="description"
                value={categoryData.description}
                onChange={handleChange}
                placeholder="Description (optional)"
                rows={3}
                style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none', resize: 'vertical', fontFamily: 'inherit' }}
              />
            </div>

            <div style={{ marginBottom: categoryData.addAsSubCat ? '1rem' : 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.875rem', fontWeight: '500', color: 'var(--etpos-text-muted, #374151)' }}>
                <input
                  type="checkbox"
                  name="addAsSubCat"
                  checked={categoryData.addAsSubCat}
                  onChange={handleChange}
                  style={{ width: '15px', height: '15px', cursor: 'pointer', accentColor: '#3b82f6' }}
                />
                Add as sub taxonomy
              </label>
            </div>

            {categoryData.addAsSubCat && (
               <div style={{ marginTop: '0.75rem' }}>
                 <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>Parent Category</label>
                 <select
                   name="parentId"
                   value={categoryData.parentId}
                   onChange={handleChange}
                   required={categoryData.addAsSubCat}
                   style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none', background: 'var(--etpos-card, #fff)' }}
                 >
                   <option value="">-- Select parent category --</option>
                   {categories.map(cat => (
                     <option key={cat.id} value={cat.id}>{cat.name}</option>
                   ))}
                 </select>
               </div>
            )}
          </div>

          <div style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid #e2e8f0', background: '#f8fafc', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', alignItems: 'center' }}>
            <button type="button" onClick={handleClose} disabled={isSaving} style={{ padding: '0.6rem 1.5rem', background: 'var(--etpos-card, #fff)', color: '#64748b', border: '1px solid #cbd5e1', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '0.875rem' }}>
              Close
            </button>
            <button
              type="submit"
              disabled={isSaving}
              style={{ padding: '0.6rem 1.75rem', background: isSaving ? '#93c5fd' : '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: isSaving ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '0.875rem', boxShadow: '0 2px 4px rgba(59,130,246,0.3)', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategoryModal;
